import { CSSProperties } from "react";
import { Motion, spring, OpaqueConfig, Style } from 'react-motion';

export const springConfig = { stiffness: 700, damping: 60 };

export interface MotionStyle {
  [key :string] :number|OpaqueConfig;
  
  scale?: number|OpaqueConfig;
  translateX?: number|OpaqueConfig;
  translateY?: number|OpaqueConfig;
  translateZ?: number|OpaqueConfig;
  rotate?: number|OpaqueConfig;
  perspective?: number|OpaqueConfig;
  opacity?: number|OpaqueConfig;
}

/**
 * Convert motion style to react css style. TODO enable other units than px
 */
export const toCssProperties = (style: MotionStyle): CSSProperties => {
  let css: CSSProperties = {};
  let transform = [];

  if (style.opacity) {
    let opacityConfig = style.opacity as OpaqueConfig;
    css.opacity = opacityConfig.val ? opacityConfig.val : style.opacity as number;    
  }

  if (style.perspective) {
    transform.push(`perspective(${style.perspective}px)`);
  }

  if (style.translateX || style.translateY || style.translateZ) {
    transform.push(`translate3d(${style.translateX}px, ${style.translateY}px, ${style.translateZ}px)`);
  }

  if (style.scale) {
    transform.push(`scale(${style.scale})`);
  }

  if (style.rotate) {
    transform.push(`rotate(${style.rotate}deg)`);
  }
  
  if (transform.length > 0) {
    css.transform = transform.join(" ");
  }

  return css;
}